import lodashOmit from 'lodash/fp/omit';

import { SR_API_ACTION_REMOVE_USER_BOOKMARK } from 'api/actionTypes';

import { DATA_TABLE_SOURCE_USER_BOOKMARKS } from 'common/dataTableConstants';

import { actionDataTableRemoveItem } from 'client/helpers/dataTables';

export default async function removeBookmark({ state, apiClient }, { listingId }) {
  await apiClient.postWithState({
    action: SR_API_ACTION_REMOVE_USER_BOOKMARK,
    state: state,
    payload: {
      listingId,
    },
    onSuccess() {
      const newBookmarksByListingId = lodashOmit(listingId, state.get(['bookmarksByListingId']));

      state.apply(['newBookmarksCount'], (count) => Math.max(0, count - 1));
      state.set(['bookmarksByListingId'], newBookmarksByListingId);
    },
  });

  return actionDataTableRemoveItem(
    { state, apiClient },
    {
      dataSource: DATA_TABLE_SOURCE_USER_BOOKMARKS,
      entityId: listingId,
    },
  );
}
